import { Outlet } from 'react-router-dom';
import { LoginLayout } from './components/LoginLayout';

export const GuestAppWrapper = () => (
  <LoginLayout>
    <Outlet />
  </LoginLayout>
);
